import React, { useState } from 'react';
import PrimaryButton from '../../components/ui/buttons/PrimaryButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import StatrysLogo from '../../images/icons/statrysLogo.svg';
import MDSubtitleText from '../../components/ui/typography/MDSubtitleText';
import XSText from '../../components/ui/typography/XSText';
import TextInput from '../../components/ui/inputs/TextInput';
import { useForm, Controller } from 'react-hook-form';
import { API_CODE, MUI_COLORS, REGEX } from '../../constants/enum';
import ValidationMessage from '../ui/ValidationMessage';
import BaseText from '../ui/typography/BaseText';
import CheckByStreamLineHq from '../../images/icons/customSvg/checkByStreamLineHq';
import MSText from '../ui/typography/MSText';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as LoginActions from './reduxStore/action';
import { handleLogin } from '../authService/auth';

function ResetPasswordForm({ resetPassword, emailForResetPassword, otpForResetPassword }) {
  const emailRegex = REGEX.EMAIL_REGEX;
  const [showConfirmPasswordError, setShowConfirmPasswordError] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState();
  const [isPasswordNotFocused, setIsPasswordNotFocused] = useState(false);
  const [inputValue, setInputValue] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const { password, confirmPassword } = inputValue;
  const [passwordValidation, setPasswordValidation] = useState({
    tenCharacters: false,
    upperCase: false,
    lowerCase: false,
    digit: false,
    specialCharacter: false,
    space: false,
    passwordMatch: false
  });
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    confirmPassword: false
  });
  const { handleSubmit, register, errors, control } = useForm();
  const onSubmit = async (data) => {
    if (isPasswordCriteriaValid() && passwordValidation.passwordMatch) {
      let payload = {
        email: emailForResetPassword,
        password: data?.password,
        otp: otpForResetPassword
      };
      const resetPasswordResponse = await resetPassword(payload);
      if (resetPasswordResponse?.status === API_CODE.STATUS_200) {
        handleLogin(resetPasswordResponse?.data?.data?.token, resetPasswordResponse?.data?.data);
      }
    }
    if (!isPasswordCriteriaValid()) {
      setShowPasswordError(true);
    }
    if (!passwordValidation.passwordMatch) {
      setShowConfirmPasswordError(true);
    }
  };
  const currentPasswordClicked = () => {
    setShowPassword({
      ...showPassword,
      currentPassword: !showPassword?.currentPassword
    });
  };
  const confirmPasswordClicked = () => {
    setShowPassword({
      ...showPassword,
      confirmPassword: !showPassword?.confirmPassword
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name === 'password') {
      if (value.length > 9) {
        setPasswordValidation((prev) => ({
          ...prev,
          tenCharacters: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          tenCharacters: false
        }));
      }

      let upperCaseRegex = REGEX.UPPER_CASE_REGEX;
      if (value.match(upperCaseRegex)) {
        setPasswordValidation((prev) => ({
          ...prev,
          upperCase: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          upperCase: false
        }));
      }

      let lowerCaseRegex = REGEX.LOWER_CASE_REGEX;
      if (value.match(lowerCaseRegex)) {
        setPasswordValidation((prev) => ({
          ...prev,
          lowerCase: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          lowerCase: false
        }));
      }

      let digitRegex = REGEX.DIGIT_CASE_REGEX;
      if (value.match(digitRegex)) {
        setPasswordValidation((prev) => ({
          ...prev,
          digit: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          digit: false
        }));
      }

      let specialCharacterRegex = REGEX.SPECIAL_CASE_REGEX;
      if (value.match(specialCharacterRegex)) {
        setPasswordValidation((prev) => ({
          ...prev,
          specialCharacter: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          specialCharacter: false
        }));
      }

      let spaceRegex = REGEX.SPACE_REGEX;
      if (!value.match(spaceRegex)) {
        setPasswordValidation((prev) => ({
          ...prev,
          space: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          space: false
        }));
      }

      if (value === confirmPassword) {
        setPasswordValidation((prev) => ({
          ...prev,
          passwordMatch: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          passwordMatch: false
        }));
      }
    }
    if (name === 'confirmPassword') {
      if (value === password) {
        setPasswordValidation((prev) => ({
          ...prev,
          passwordMatch: true
        }));
      } else {
        setPasswordValidation((prev) => ({
          ...prev,
          passwordMatch: false
        }));
      }
    }
  };

  const isPasswordCriteriaValid = () => {
    if (
      passwordValidation.tenCharacters &&
      passwordValidation.upperCase &&
      passwordValidation.lowerCase &&
      passwordValidation.digit &&
      passwordValidation.space &&
      passwordValidation.specialCharacter
    ) {
      return true;
    }
    return false;
  };

  const onBlur = () => {
    setIsPasswordNotFocused(true);
  };
  const onFocus = () => {
    setIsPasswordNotFocused(false);
  };

  return (
    <div className="flex lg:px-32 md:px-20 px-8 w-full">
      <div className="flex flex-col justify-center h-full w-full">
        <img src={StatrysLogo} className="login-logo" alt="statrys-logo" />
        <MDSubtitleText className="md:whitespace-pre-line mt-8" title={`Reset your password`} />
        <XSText title={`Enter your new password`} className="mt-4 md:whitespace-pre-line" />
        <form id="confirm-email-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="md:w-10/12 mt-10 ">
            <Controller
              control={control}
              name="email"
              render={({ value }) => (
                <TextInput
                  defaultValue={emailForResetPassword}
                  name="email"
                  label="Email Address"
                  variant="filled"
                  value={value}
                  disabled={true}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: emailRegex,
                      message: 'Please fill in a valid Email Address'
                    }
                  })}
                  error={errors?.email ? true : false}
                  helperText={errors?.email && <ValidationMessage title={'Please fill in a valid Email Address'} />}
                />
              )}
            />
            <div className="relative flex flex-col-reverse md:flex-row md:justify-center items-center">
              <div
                className={`${
                  password && !isPasswordCriteriaValid() && !isPasswordNotFocused ? 'block mt-4' : 'hidden'
                } p-4 md:absolute  md:bg-white bg-green-200 rounded-lg ${
                  showPasswordError
                    ? 'create-password-validation-container-on-error'
                    : 'create-password-validation-container'
                }`}
              >
                <BaseText className="mb-4" fontWeight="text-bold" title={'Your password must have:'} />
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.tenCharacters ? (
                    <CheckByStreamLineHq fill={MUI_COLORS.GREEN} />
                  ) : (
                    <CheckByStreamLineHq />
                  )}
                  <MSText
                    textColor={passwordValidation.tenCharacters ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.tenCharacters && 'text-bold'}
                    title={'At least 10 characters'}
                  />
                </div>
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.upperCase ? (
                    <CheckByStreamLineHq fill={MUI_COLORS.GREEN} />
                  ) : (
                    <CheckByStreamLineHq />
                  )}
                  <MSText
                    textColor={passwordValidation.upperCase ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.upperCase && 'text-bold'}
                    title={'At least one uppercase letter'}
                  />
                </div>
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.lowerCase ? (
                    <CheckByStreamLineHq fill={MUI_COLORS.GREEN} />
                  ) : (
                    <CheckByStreamLineHq />
                  )}
                  <MSText
                    textColor={passwordValidation.lowerCase ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.lowerCase && 'text-bold'}
                    title={'At least one lowercase letter'}
                  />
                </div>
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.digit ? <CheckByStreamLineHq fill={MUI_COLORS.GREEN} /> : <CheckByStreamLineHq />}
                  <MSText
                    textColor={passwordValidation.digit ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.digit && 'text-bold'}
                    title={'At least one digit number'}
                  />
                </div>
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.space ? <CheckByStreamLineHq fill={MUI_COLORS.GREEN} /> : <CheckByStreamLineHq />}
                  <MSText
                    textColor={passwordValidation.space ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.space && 'text-bold'}
                    title={'No spaces'}
                  />
                </div>
                <div className="flex gap-2 items-center mt-2">
                  {passwordValidation.specialCharacter ? (
                    <CheckByStreamLineHq fill={MUI_COLORS.GREEN} />
                  ) : (
                    <CheckByStreamLineHq />
                  )}
                  <MSText
                    textColor={passwordValidation.specialCharacter ? 'text-green-signup' : 'text-light-gray'}
                    fontWeight={passwordValidation.specialCharacter && 'text-bold'}
                    title={'At least one special character ( # * ! etc. )'}
                  />
                </div>
                <div className="absolute w-full left-0 right-0 mx-auto mt-5 validation-div-triangle-down"></div>
              </div>
              <div className="w-full">
                <Controller
                  control={control}
                  name="password"
                  render={({ value }) => (
                    <TextInput
                      type={showPassword?.currentPassword ? 'text' : 'password'}
                      label="Password"
                      name="password"
                      onRightSideAdornment={currentPasswordClicked}
                      value={value}
                      onChange={handleChange}
                      endAdornment={showPassword?.currentPassword ? <Visibility /> : <VisibilityOff />}
                      textFieldContainerClass="mt-4"
                      inputRef={register({
                        required: true
                      })}
                      onBlur={onBlur}
                      onFocus={onFocus}
                      error={errors?.password ? true : false}
                      helperText={errors?.password && <ValidationMessage title={'Please fill in a valid password'} />}
                    />
                  )}
                />
              </div>
            </div>
            <Controller
              control={control}
              name="confirmPassword"
              render={({ value }) => (
                <TextInput
                  type={showPassword?.confirmPassword ? 'text' : 'password'}
                  label="Confirm Password"
                  name="confirmPassword"
                  onRightSideAdornment={confirmPasswordClicked}
                  endAdornment={showPassword?.confirmPassword ? <Visibility /> : <VisibilityOff />}
                  textFieldContainerClass="mt-4"
                  value={value}
                  onChange={handleChange}
                  inputRef={register({
                    required: true
                  })}
                  error={errors?.confirmPassword || showConfirmPasswordError ? true : false}
                  helperText={
                    (errors?.confirmPassword || showConfirmPasswordError) && (
                      <ValidationMessage title={'Both passwords must be same'} />
                    )
                  }
                />
              )}
            />
            <PrimaryButton
              id="reset-password-form-btn"
              bgColor="bg-coral-500"
              className="button w-full mt-6"
              caption="Confirm"
              onClick={handleSubmit(onSubmit)}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (resetPasswordPayload) => dispatch(LoginActions.resetPassword(resetPasswordPayload))
  };
};

export default connect(null, mapDispatchToProps)(ResetPasswordForm);
ResetPasswordForm.propTypes = {
  resetPassword: PropTypes.func,
  emailForResetPassword: PropTypes.string,
  otpForResetPassword: PropTypes.string
};
